import { lmsClient } from "api";

const lmsRestrukturisasiService = {};

/**
 * 1. Listing Loan candidate untuk Restrukturisasi
 * support pagination & filter
 */
lmsRestrukturisasiService.getLoans = function (data) {
  const params = new URLSearchParams();

  // Pagination
  if (data?.pageSize) params.append("pageSize", data.pageSize);
  if (data?.pageIndex) params.append("page", data.pageIndex);

  // Filter optional
  if (data?.branchId) params.append("branchId", data.branchId);
  if (data?.name) params.append("name", data.name);
  if (data?.loanNo) params.append("loanNo", data.loanNo);

  return lmsClient({
    url: `/lms/restrukturisasi/paging?${params.toString()}`,
    method: "get",
  });
};

/**
 * 2. Pengajuan Restrukturisasi
 */
lmsRestrukturisasiService.createPengajuan = function (payload) {
  return lmsClient({
    url: `/lms/restrukturisasi`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  });
};

export default lmsRestrukturisasiService;
